import { createAppInstance } from './config/app';
import { initializeLogger } from './config/logger';
import { initApi } from './services/api';
import router from './router';
import { Capacitor } from '@capacitor/core';
import { setupDeepLinkListener } from '@/native/deepLink';
import { useAuthFacade } from '@/auth/facade/authFacade';
import { appAuth } from '@/auth/platform/appAuth';
import { tokenService } from '@/services/http/tokenService';

initializeLogger();

const { app } = createAppInstance();

app.use(router);

app.mount('#app');

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
initApi(API_BASE_URL, {
  isTokenAuth: () => Capacitor.isNativePlatform(),
  getAccessToken: () => appAuth.getAccessToken(),
  refreshAuth: async (baseURL) => {
    const tokens = await tokenService(baseURL);

    if (tokens?.access_token) {
      await appAuth.setTokens(tokens);
    }

    return tokens;
  },
  logout: async () => {
    const auth = useAuthFacade();
    await auth.logout({ isForce: true });
  },
});

if (Capacitor.isNativePlatform()) {
  setupDeepLinkListener();
}
